module.exports = __webpack_public_path__ + "img/ring_y_0_1_0@3x.2941198d.png";